import React from "react";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Font,
  Image,
  PDFViewer,
} from "@react-pdf/renderer";

// Styles for the PDF document
const styles = StyleSheet.create({
  page: {
    padding: 15,
    border: "1px solid #333",
  },
  fontBold: { fontWeight: "bold" },
  header: {
    marginBottom: 10,
    textAlign: "right",
    borderBottom: "1px solid #333",
    paddingBottom: 5,
  },
  title: {
    fontSize: 15,
    fontWeight: "bold",
    marginBottom: 2,
  },
  subTitle: {
    fontSize: 11,
    fontWeight: "bold",
  },
  section: {
    marginBottom: 10,
  },
  row: {
    flexDirection: "row",
  },
  bgText: {
    backgroundColor: "#000",
    marginBottom: 6,
    padding: 5,
    fontSize: 10,
    fontWeight: "bold",
    // width: "20",
    alignSelf: "flex-start",
    color: "#fff",
    display: "inline",
  },
  infoText: {
    fontSize: 10,
    marginBottom: 2,
    color: "#333",
  },
  table: {
    display: "table",
    width: "100%",
    borderStyle: "solid",
    borderWidth: 1,
    borderRightWidth: 0,
  },
  tableRow: {
    flexDirection: "row",
  },
  tableCol: {
    width: "15%",
    borderStyle: "solid",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    padding: 5,
    fontSize: 10,
  },
  tableCell: {
    fontSize: 8,
  },
  footer: {
    fontSize: 8,
    textAlign: "center",
    marginTop: 2,
  },
});

// Table Row Generator
const TableRow = ({ data, borderType = "" }) => (
  <View style={styles.tableRow}>
    <View
      style={[styles.tableCol, { borderBottomWidth: borderType, width: "5%" }]}
    >
      <Text style={styles.tableCell}>{data?.sn || ""}</Text>
    </View>
    <View
      style={[styles.tableCol, { borderBottomWidth: borderType, width: "20%" }]}
    >
      <Text style={styles.tableCell}>{data?.itemCode || ""}</Text>
    </View>
    <View
      style={[styles.tableCol, { borderBottomWidth: borderType, width: "25%" }]}
    >
      <Text style={[styles.tableCell, { fontSize: 7 }]}>
        {data?.itemName || ""}
      </Text>
    </View>
    <View
      style={[styles.tableCol, { borderBottomWidth: borderType, width: "10%" }]}
    >
      <Text style={styles.tableCell}>{data?.qty || ""}</Text>
    </View>
    <View style={[styles.tableCol, { borderBottomWidth: borderType }]}>
      <Text style={styles.tableCell}>{data?.rate || ""}</Text>
    </View>
    <View style={[styles.tableCol, { borderBottomWidth: borderType }]}>
      <Text style={styles.tableCell}>{data?.taxableAmt || ""}</Text>
    </View>{" "}
    <View style={[styles.tableCol, { borderBottomWidth: borderType }]}>
      <Text style={styles.tableCell}>{data?.taxAmt || ""}</Text>
    </View>{" "}
    <View style={[styles.tableCol, { borderBottomWidth: borderType }]}>
      <Text style={styles.tableCell}>{data?.totalAmt || ""}</Text>
    </View>{" "}
    {/* <View style={[styles.tableCol, { borderBottomWidth: borderType }]}>
      <Text style={styles.tableCell}>{data?.mkp || ""}</Text>
    </View>{" "}
    <View
      style={[styles.tableCol, { borderBottomWidth: borderType, width: "10%" }]}
    >
      <Text style={styles.tableCell}>{data?.mrg || ""}</Text>
    </View> */}
  </View>
);
const OctoletPdf = ({
  record = {},
  pages = [],
  ROWS_PER_PAGE = 15,
  taxData = [],
}) => {
  console.log("record.store_details?.store_image", record);
  return (
    <Document>
      {pages.map((pageData, pageIndex) => (
        <Page key={pageIndex} size="A4" style={styles.page}>
          {/* Header */}
          <View style={styles.header}>
            <View style={[styles.row, { justifyContent: "space-between" }]}>
              <View>
                <Image
                  src={"/images/logo.jpg"}
                  alt="Ocelot logo"
                  style={{
                    // width: 70,
                    height: 50,
                    objectFit: "contain",
                    marginHorizontal: "auto",
                  }}
                />
              </View>
              <View>
                <Text style={styles.title}>
                  {record.store_details?.first_name +
                    " " +
                    record.store_details?.last_name}
                </Text>
                <Text style={styles.subTitle}>
                  {record.store_details?.store_city +
                    ", " +
                    record.store_details?.store_ward +
                    ", " +
                    record.store_details?.store_state}
                </Text>
                <Text style={styles.subTitle}>
                  {record.store_details?.store_email}
                </Text>{" "}
                <Text style={styles.subTitle}>
                  {record.store_details?.store_phone}
                </Text>
              </View>
            </View>
          </View>

          {/* Supplier & Store Details */}
          {pageIndex === 0 && (
            <>
              <Text
                style={{
                  fontSize: 18,
                  fontWeight: "bold",
                  marginBottom: 15,
                  textTransform: "uppercase",
                }}
              >
                {record.order_type}
              </Text>
              <View style={[styles.row, { marginBottom: 10 }]}>
                <View style={{ flex: 0.65 }}>
                  {/* Supplier and Store Information */}
                  <View style={styles.row}>
                    <View style={{ flex: 0.5 }}>
                      <Text style={styles.bgText}>Invoice From</Text>
                      <Text style={styles.infoText}>
                        Name: {record.store_details?.store_name}
                      </Text>

                      <Text style={styles.infoText}>
                        Email: {record.store_details?.store_email}
                      </Text>
                      <Text style={styles.infoText}>
                        Tel: {record.store_details?.store_phone}
                      </Text>
                    </View>
                    <View style={{ flex: 0.5 }}>
                      <Text style={styles.bgText}>Invoice To</Text>
                      <Text style={styles.infoText}>
                        Name:{" "}
                        {record.customer?.cust_first_name +
                          " " +
                          record.customer?.cust_last_name}
                      </Text>
                      <Text style={styles.infoText}>
                        Email: {record.customer?.cust_email}
                      </Text>

                      <Text style={styles.infoText}>
                        Tel: {record.customer?.cust_phone}
                      </Text>
                    </View>
                  </View>
                </View>

                {/* Invoice Details */}
                <View style={{ flex: 0.35, paddingLeft: 10 }}>
                  {/* {invoiceData.map((item, index) => (
                    <View
                      key={index}
                      style={[
                        styles.row,
                        { marginBottom: 2, alignItems: "center" },
                      ]}
                    >
                      <View style={{ flex: 0.5, paddingRight: 5 }}>
                        <Text
                          style={{
                            fontSize: 8,
                            color: "#333",
                            fontWeight: "bold",
                            textAlign: "right",
                          }}
                        >
                          {item.title}:
                        </Text>
                      </View>
                      <View style={{ flex: 0.5 }}>
                        <Text
                          style={{
                            fontSize: 8,
                            color: "#333",
                            fontWeight: "bold",
                            backgroundColor: "#eee",
                            padding: 2,
                            borderRadius: 2,
                            textAlign: "right",
                            border: "1px solid #ccc",
                          }}
                        >
                          {item.value}
                        </Text>
                      </View>
                    </View>
                  ))} */}
                  <View
                    style={[
                      styles.row,
                      { marginBottom: 2, alignItems: "center" },
                    ]}
                  >
                    <View style={{ flex: 0.5, paddingRight: 5 }}>
                      <Text
                        style={{
                          fontSize: 8,
                          color: "#333",
                          fontWeight: "bold",
                          textAlign: "right",
                        }}
                      >
                        Order No:
                      </Text>
                    </View>
                    <View style={{ flex: 0.5 }}>
                      <Text
                        style={{
                          fontSize: 8,
                          color: "#333",
                          fontWeight: "bold",
                          backgroundColor: "#eee",
                          padding: 2,
                          borderRadius: 2,
                          textAlign: "right",
                          border: "1px solid #ccc",
                        }}
                      >
                        {record.order_no}
                      </Text>
                    </View>
                  </View>
                  <View
                    style={[
                      styles.row,
                      { marginBottom: 2, alignItems: "center" },
                    ]}
                  >
                    <View style={{ flex: 0.5, paddingRight: 5 }}>
                      <Text
                        style={{
                          fontSize: 8,
                          color: "#333",
                          fontWeight: "bold",
                          textAlign: "right",
                        }}
                      >
                        Created Date:
                      </Text>
                    </View>
                    <View style={{ flex: 0.5 }}>
                      <Text
                        style={{
                          fontSize: 8,
                          color: "#333",
                          fontWeight: "bold",
                          backgroundColor: "#eee",
                          padding: 2,
                          borderRadius: 2,
                          textAlign: "right",
                          border: "1px solid #ccc",
                        }}
                      >
                        {new Date(record.created_date).toLocaleDateString()}
                      </Text>
                    </View>
                  </View>
                  <View
                    style={[
                      styles.row,
                      { marginBottom: 2, alignItems: "center" },
                    ]}
                  >
                    <View style={{ flex: 0.5, paddingRight: 5 }}>
                      <Text
                        style={{
                          fontSize: 8,
                          color: "#333",
                          fontWeight: "bold",
                          textAlign: "right",
                        }}
                      >
                        Terms:
                      </Text>
                    </View>
                    <View style={{ flex: 0.5 }}>
                      <Text
                        style={{
                          fontSize: 8,
                          color: "#333",
                          fontWeight: "bold",
                          backgroundColor: "#eee",
                          padding: 2,
                          borderRadius: 2,
                          textAlign: "right",
                          border: "1px solid #ccc",
                        }}
                      >
                        DUE
                      </Text>
                    </View>
                  </View>
                  <View
                    style={[
                      styles.row,
                      { marginBottom: 2, alignItems: "center" },
                    ]}
                  >
                    <View style={{ flex: 0.5, paddingRight: 5 }}>
                      <Text
                        style={{
                          fontSize: 8,
                          color: "#333",
                          fontWeight: "bold",
                          textAlign: "right",
                        }}
                      >
                        Amount Due:
                      </Text>
                    </View>
                    <View style={{ flex: 0.5 }}>
                      <Text
                        style={{
                          fontSize: 8,
                          color: "#333",
                          fontWeight: "bold",
                          backgroundColor: "#eee",
                          padding: 2,
                          borderRadius: 2,
                          textAlign: "right",
                          border: "1px solid #ccc",
                        }}
                      >
                        {record.total_amount}
                      </Text>
                    </View>
                  </View>
                </View>
              </View>
            </>
          )}

          {/* Product Table */}
          <View style={styles.table}>
            {/* Table Header */}
            <View style={styles.tableRow}>
              <View style={[styles.tableCol, { width: "5%" }]}>
                <Text style={styles.tableCell}>SN</Text>
              </View>
              <View style={[styles.tableCol, { width: "20%" }]}>
                <Text style={styles.tableCell}>Item Code</Text>
              </View>
              <View style={[styles.tableCol, { width: "25%" }]}>
                <Text style={styles.tableCell}>Item Name</Text>
              </View>
              <View style={[styles.tableCol, { width: "10%" }]}>
                <Text style={styles.tableCell}>Qty</Text>
              </View>
              <View style={styles.tableCol}>
                <Text style={styles.tableCell}>Rate</Text>
              </View>
              <View style={styles.tableCol}>
                <Text style={styles.tableCell}>Taxable Amt</Text>
              </View>{" "}
              <View style={styles.tableCol}>
                <Text style={styles.tableCell}>Tax Amt</Text>
              </View>{" "}
              <View style={styles.tableCol}>
                <Text style={styles.tableCell}>Total Amt</Text>
              </View>{" "}
              {/* <View style={styles.tableCol}>
                <Text style={styles.tableCell}>Mkp%</Text>
              </View>{" "}
              <View style={[styles.tableCol, { width: "10%" }]}>
                <Text style={styles.tableCell}>Mrg%</Text>
              </View> */}
            </View>

            {/* Product Rows */}
            {pageData.map((product, index) => (
              <TableRow
                key={index}
                data={{ ...product, sn: pageIndex * ROWS_PER_PAGE + index + 1 }}
              />
            ))}

            {/* Filler Rows */}
            {Array.from({ length: ROWS_PER_PAGE - pageData.length }).map(
              (_, fillerIndex) => (
                <TableRow key={`blank-${fillerIndex}`} borderType={0} />
              )
            )}
          </View>
          {/* {pageIndex === pages.length - 1 && (
            <View
              style={[
                styles.row,
                styles.subTitle,
                { justifyContent: "space-between", marginTop: 10 },
              ]}
            >
              <Text> Total Records: {AddedItemsData.total_records}</Text>
              <Text> Total Items: {AddedItemsData.total_quantity}</Text>
              <Text>
                Total Cost Of Goods: {AddedItemsData.total_goods_value}
              </Text>
            </View>
          )} */}
          {pageIndex === pages.length - 1 && (
            <View style={[styles.row, { marginTop: 20 }]}>
              <View style={{ flex: 0.3, paddingRight: 40, marginTop: 20 }}>
                {/* {creatorData.map((item, index) => (
                  <View
                    key={index}
                    style={[
                      styles.row,
                      { marginBottom: 2, alignItems: "center" },
                    ]}
                  >
                    <View style={{ flex: 0.5, paddingRight: 5 }}>
                      <Text
                        style={{
                          fontSize: 10,
                          color: "#333",
                          fontWeight: "bold",
                          textAlign: "right",
                        }}
                      >
                        {item.title}:
                      </Text>
                    </View>
                    <View style={{ flex: 0.5 }}>
                      <Text
                        style={{
                          fontSize: 10,
                          color: "#333",
                          fontWeight: "bold",
                          backgroundColor: "#eee",
                          padding: 3,
                          borderRadius: 2,
                          textAlign: "right",
                          border: "1px solid #ccc",
                        }}
                      >
                        {item.value}
                      </Text>
                    </View>
                  </View>
                ))} */}
              </View>

              <View style={{ flex: 0.7 }}>
                <Text style={styles.title}>TAX SUMMARY</Text>
                <View style={styles.table}>
                  <View
                    style={[
                      styles.tableRow,
                      { borderBottom: "1px solid #000" },
                    ]}
                  >
                    <Text
                      style={{
                        fontSize: 10,
                        flex: 0.25,
                        paddingVertical: 2,
                        paddingHorizontal: 5,
                        borderRight: "1px solid #000",
                      }}
                    >
                      Tax Rate
                    </Text>
                    <Text
                      style={{
                        fontSize: 10,
                        flex: 0.25,
                        paddingVertical: 2,
                        paddingHorizontal: 5,
                        borderRight: "1px solid #000",
                      }}
                    >
                      Taxable Amt
                    </Text>
                    <Text
                      style={{
                        fontSize: 10,
                        flex: 0.25,
                        paddingVertical: 2,
                        paddingHorizontal: 5,
                        borderRight: "1px solid #000",
                      }}
                    >
                      Tax Amt
                    </Text>
                    <Text
                      style={{
                        fontSize: 10,
                        flex: 0.25,
                        paddingVertical: 2,
                        paddingHorizontal: 5,
                        borderRight: "1px solid #000",
                      }}
                    >
                      Total Amt
                    </Text>
                  </View>

                  {taxData.map((row, index) => (
                    <View
                      style={[
                        styles.tableRow,
                        { borderBottom: "1px solid #000" },
                      ]}
                      key={index}
                    >
                      <Text
                        style={{
                          fontSize: 10,
                          flex: 0.25,
                          paddingVertical: 2,
                          paddingHorizontal: 5,
                          borderRight: "1px solid #000",
                        }}
                      >
                        {row.taxRate}
                      </Text>
                      <Text
                        style={{
                          fontSize: 10,
                          flex: 0.25,
                          paddingVertical: 2,
                          paddingHorizontal: 5,
                          borderRight: "1px solid #000",
                        }}
                      >
                        {row.taxableAmt}
                      </Text>
                      <Text
                        style={{
                          fontSize: 10,
                          flex: 0.25,
                          paddingVertical: 2,
                          paddingHorizontal: 5,
                          borderRight: "1px solid #000",
                        }}
                      >
                        {row.taxAmt}
                      </Text>
                      <Text
                        style={{
                          fontSize: 10,
                          flex: 0.25,
                          paddingVertical: 2,
                          paddingHorizontal: 5,
                          borderRight: "1px solid #000",
                        }}
                      >
                        {row.totalAmt}
                      </Text>
                    </View>
                  ))}
                </View>
              </View>
            </View>
          )}

          {/* Footer */}
          <View
            style={{
              textAlign: "center",
              width: "100%",
              marginTop: 10,
              position: "absolute",
              bottom: 30,
              left: 0,
              right: 0,
            }}
          >
            <Image
              src={"/images/logo.jpg"}
              alt="Ocelot logo"
              style={{
                // width: 70,
                height: 35,
                objectFit: "contain",
                marginHorizontal: "auto",
              }}
            />
            <Text style={styles.footer}>
              This Receipt was generated with the help of Ocelot Links POS.
            </Text>
            <Text style={styles.footer}>
              Learn more and create your own free trial account by visiting
              ocelotlinks.com or call 0711664444 for assistance.
            </Text>
            <Text style={[styles.footer, styles.fontBold]}>
              Powered by Ocelot Technologies Ltd
            </Text>
          </View>
        </Page>
      ))}
    </Document>
  );
};

export default OctoletPdf;
